import React from 'react';
import { BaasicInput, BaasicSelect, Loader } from 'core/components';
import { translate, isSome } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

function SellerCreateTemplate({ sellerCreateViewStore, t }) {
	const {
		form,
		loading,
		organizationTypeOptions,
		onOrganizationTypeSelect,
		selectedOrganizationType,
		isWarehouseOrganizationType,
	} = sellerCreateViewStore;
	if (loading) return <Loader />;
	return (
		<form className="form" onSubmit={form.onSubmit}>
			<h3 className="spc--bottom--sml">
				{t('CREATE')} {t('ORGANIZATION.LABEL')}
			</h3>
			<div className="inputgroup">
				<BaasicSelect
					field={form.$('organizationType.id')}
					clearable={false}
					options={organizationTypeOptions}
					value={selectedOrganizationType}
					onChange={onOrganizationTypeSelect}
				/>
			</div>
			<BaasicInput field={form.$('identifier')} />
			<BaasicInput field={form.$('applicationTitle')} />
			<BaasicInput field={form.$('email')} />

			<div className="row">
				<div className="col col-sml-6">
					<BaasicInput field={form.$('password')} />
				</div>
				<div className="col col-sml-6">
					<BaasicInput field={form.$('confirmPassword')} />
				</div>
			</div>
			{isSome(isWarehouseOrganizationType) && isWarehouseOrganizationType && (
				<div>
					<BaasicInput field={form.$('identifier')} />
					<BaasicInput field={form.$('applicationTitle')} />
					<BaasicInput field={form.$('email')} />
				</div>
			)}
			{form.error && (
				<div>
					<p className="type--color--warning">{translate(form.error)}</p>
				</div>
			)}
			<div>
				<button className="btn btn--med btn--primary" type="submit" disabled={loading}>
					{loading ? (
						<div className="spinnercont spc--right--sml">
							<div className="spinner"></div>
						</div>
					) : null}
					{t('SAVE')}
				</button>
			</div>
		</form>
	);
}

export default defaultTemplate(SellerCreateTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/seller/pages/SellerCreateTemplate.jsx